import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const miniCalendarStyleId = 'wb-v2-mini-calendar-theme';

export const miniCalendarBridgeStyles = {
  'wb-mini-calendar': {
    '--local-calendar-bg': tokens.color.background.primary,
    '--local-calendar-font-family': tokens.font.family.body,
    '--local-calendar-gap': '2px',
    '--local-calendar-cell-height': '30px',
    '--local-calendar-cell-radius': tokens.radius.xs,
    '--local-calendar-focus-ring': tokens.focusRing.default,
    '--local-calendar-nav-color': tokens.color.foreground.quaternary,
    '--local-calendar-nav-hover-color': tokens.color.foreground.brandPrimary,
    '--local-calendar-nav-hover-bg': tokens.color.background.secondary,
    '--local-calendar-nav-size': '24px',
    '--local-calendar-title-color': tokens.color.text.primary,
    '--local-calendar-title-font-size': tokens.font.size.textMdBase,
    '--local-calendar-title-font-weight': tokens.font.weight.semibold,
    '--local-calendar-title-line-height': tokens.lineHeight.textMd,
    '--local-calendar-weekday-color': tokens.color.text.tertiary,
    '--local-calendar-weekday-font-size': tokens.font.size.textXs,
    '--local-calendar-weekday-font-weight': tokens.font.weight.semibold,
    '--local-calendar-weekday-line-height': tokens.lineHeight.textXs,
    '--local-calendar-day-color': tokens.color.text.secondary,
    '--local-calendar-day-font-size': tokens.font.size.textSm,
    '--local-calendar-day-line-height': tokens.lineHeight.textSm,
    '--local-calendar-day-hover-bg': tokens.color.background.secondary,
    '--local-calendar-day-disabled-color': tokens.color.text.disabled,
    '--local-calendar-today-ring': tokens.color.border.secondary,
    '--local-calendar-selected-bg': tokens.color.background.brandSolid,
    '--local-calendar-selected-hover-bg': tokens.color.background.brandSolidHover,
    '--local-calendar-selected-color': tokens.color.text.primaryOnBrand,
    '--local-calendar-in-range-bg': tokens.componentColors.utility.brand50,
    '--local-calendar-in-range-color': tokens.componentColors.utility.brand700,
    // The pending band and its far end. Same brand family as the committed tint, one step lighter, so
    // "would be" is legible beside "is" without introducing a second hue.
    '--local-calendar-preview-bg': tokens.componentColors.utility.brand50,
    '--local-calendar-preview-color': tokens.componentColors.utility.brand700,
    '--local-calendar-preview-ring': tokens.componentColors.utility.brand200,
    '--local-calendar-panel-gap': tokens.spacing.xl,
    '--local-calendar-header-gap': tokens.spacing.xs,
    '--local-calendar-header-margin': tokens.spacing.sm,
    // Breathing room between the `Today` shortcut and the next chevron, on top of the header's own gap.
    '--local-calendar-today-gap': tokens.spacing.xs,
  },
};
